import styled from 'styled-components';
import { VStack, Typography, HStack } from '@vivaahealth/design-system';

import LoadingBar from '../../components/LoadingBar';

interface Props {
  loadingHeader: string;
  loadingSubheader?: string;
}

const Loading = ({ loadingHeader, loadingSubheader }: Props) => {
  return (
    <HStack justifyContent={'center'} height={'100%'}>
      <LoadingBar
        label={
          <VStack alignItems={'center'} gap={8}>
            <Typography variant="headline-small" bold>
              {loadingHeader}
            </Typography>

            {loadingSubheader && (
              <StyledText variant="paragraph-large">
                {loadingSubheader}
              </StyledText>
            )}
          </VStack>
        }
      ></LoadingBar>
    </HStack>
  );
};

export default Loading;

const StyledText = styled(Typography)`
  text-align: center;
`;
